@if (errors) {
  <div class="invalid-feedback" aria-live="assertive" aria-atomic="true">
    @if (errors && errors['pattern']) {
      {{ 'content.incorrect-format' | translate }}
    }
    @if (errors && errors['required']) {
      {{ 'content.required' | translate }}
    }
    @if (errors && errors['maxlength']) {
      {{ 'content.value-cannot-be-longer-than' | translate:{size: errors['maxlength']['requiredLength']} }}
    }
    @if (errors && errors['minlength']) {
      {{ 'content.value-cannot-be-shorter-than' | translate:{size: errors['minlength']['requiredLength']} }}
    }
    @if (errors && errors['phone']) {
      {{ 'content.phone-invalid' | translate }}
    }
    @if (errors && errors['invalidDate']) {
      {{ 'content.date-invalid' | translate }}
    }
    @if (errors && !errors['notSame'] && errors['email']) {
      {{ 'content.email-invalid' | translate }}
    }
    @if (errors && errors['incorrectPassword']) {
      {{ 'content.password-incorrect' | translate }}
    }
    @if (errors && !errors['required'] && errors['notSame']) {
      {{ 'content.field-mismatch' | translate }}
    }
    @if (errors && errors['non-existent']) {
      {{ 'content.does-not-exist' | translate }}
    }
    @if (errors && errors['branch-already-on-company']) {
      {{ 'content.branch-already-on-company' | translate }}
    }
    @if (errors && !errors['required'] && errors['oneOf']) {
      {{ 'content.requires-one-of' | translate }}
    }
    @if (errors && !errors['invalidDate'] && !errors['phone']  && (errors['Mask error'] || errors['mask'])) {
      {{ 'content.incorrect-format' | translate }}
    }
    @if (errors && errors['startEndTime']) {
      {{ 'content.start-time-end-time-order' | translate }}
    }
    @if (errors && errors['sin']) {
      {{ 'content.sin-invalid' | translate }}
    }
    @if (errors && !errors['required'] && containsPasswordValidationErrors) {
      <ul>
        <!-- Make sure all of the below error possibilities are caught by containsPasswordValidationErrors -->
        @if (errors['tooShort']) {
          <li>{{ 'content.too-short' | translate }}</li>
        }
        @if (errors['tooLong']) {
          <li>{{ 'content.too-long' | translate }}</li>
        }
        @if (errors['doesNotContainLcAlpha']) {
          <li>{{ 'content.requires-alpha-character-lc' | translate }}</li>
        }
        @if (errors['doesNotContainUcAlpha']) {
          <li>{{ 'content.requires-alpha-character-uc' | translate }}</li>
        }
        @if (errors['doesNotContainNum']) {
          <li>{{ 'content.requires-number' | translate }}</li>
        }
        @if (errors['doesNotContainSpecial']) {
          <li>{{ 'content.requires-special-character' | translate }}</li>
        }
        @if (errors['containsSequence'] || errors['doesNotContainSequentialAlpha'] || errors['doesNotContainSequentialNumber']) {
          <li>{{ 'content.requires-no-sequence' | translate }}</li>
        }
        @if (errors['doesNotContainsWhiteSpace']) {
          <li>{{ 'content.requires-no-space' | translate }}</li>
        }
      </ul>
    }
    @if (errors && !errors['required'] && errors['recentlyUsedPassword']) {
      {{ 'content.recently.used.password' | translate }}
    }
    @if (errors && errors['mfaWrongCode']) {
      {{ 'content.mfa-incorrect-code' | translate }}
    }
  </div>
}
